<div class="bg-m0 h-full w-full min-w-[2px] select-none rounded shadow">
  <div class="flex h-full w-full flex-col">
    <div class="mb-6 mt-6 flex h-11 w-full flex-shrink-0 flex-row items-center">
      <div
        class="text-s1 ml-[36px] min-w-[2px] max-w-max flex-grow truncate text-lg"
        >{{ secondFileName }}
      </div>

      <div
        tp="Selected file has error"
        [tpIsEnabled]="isSecondFileValid === false"
      >
        <button
          class="ml-5 flex flex-shrink-0 flex-row items-center focus:outline-none"
          [ngClass]="{
            'text-s400': isSecondFileValid === false,
            'text-m600': isSecondFileValid === true
          }"
          *ngIf="
            showGoTo === true &&
            ((isExplorer === true &&
              ((secondFileName | goFromFileExt) === 'chart' ||
                (secondFileName | goFromFileExt) === 'malloy' ||
                (secondFileName | goFromFileExt) === 'store')) ||
              (secondFileName | goFromFileExt) === 'report' ||
              (secondFileName | goFromFileExt) === 'dashboard')
          "
          (click)="goTo()"
          [disabled]="isSecondFileValid === false"
        >
          <m-arrow-narrow-right-icon></m-arrow-narrow-right-icon>

          <div class="ml-2 text-lg">
            {{
              (secondFileName | goFromFileExt) === 'malloy' ||
              (secondFileName | goFromFileExt) === 'store'
                ? 'Model'
                : (secondFileName | goFromFileExt | capitalize)
            }}</div
          >
        </button>
      </div>

      <div class="flex flex-1"></div>

      <div
        class="ml-5 flex-shrink-0"
        tp="Edit file in the left tab"
        [tpIsEnabled]="secondFileNodeId === mainFileNodeId"
      >
        <button
          class="flex flex-shrink-0 flex-row items-center focus:outline-none"
          [ngClass]="{
            'text-m600': secondFileNodeId !== mainFileNodeId,
            'text-s400 cursor-default': secondFileNodeId === mainFileNodeId
          }"
          (click)="goToEditFile()"
        >
          <m-arrow-narrow-right-icon></m-arrow-narrow-right-icon>

          <div class="ml-2 text-lg"> Edit File</div>
        </button>
      </div>

      <button
        type="button"
        data-cy="filesRightCloseButton"
        class="text-s1 hover:bg-m200 ml-5 mr-6 flex h-9 w-9 flex-shrink-0 select-none items-center justify-center rounded focus:outline-none"
        (click)="closeSecondFile()"
      >
        <m-delete-big-icon></m-delete-big-icon>
      </button>
    </div>

    <div class="divide-s300 ml-6 mr-6 flex flex-col divide-y">
      <div class="flex flex-row"></div>
      <div class="flex flex-row"></div>
    </div>

    <div
      *ngIf="isShowSpinner === true"
      class="flex h-full w-full items-center justify-center"
    >
      <div class="relative flex h-9 w-9 flex-shrink-0">
        <ngx-spinner
          [name]="spinnerName"
          color="#0084d1"
          bdColor="#00000000"
          size="default"
          type="ball-clip-rotate"
          [fullScreen]="false"
          [disableAnimation]="true"
          [zIndex]="10"
        >
        </ngx-spinner>
      </div>
    </div>

    <div
      class="flex h-2 w-full flex-grow flex-row pl-6 pr-6"
      *ngIf="
        isShowSpinner === false &&
        isEditorOptionsInitComplete === true &&
        !!secondFileNodeId &&
        secondFileContent != null
      "
    >
      <div class="flex w-2 flex-1">
        <code-editor
          class="w-full outline-none"
          style="height: 100%"
          [(ngModel)]="secondFileContent"
          [readonly]="true"
          [extensions]="extensions"
          [languages]="languages"
          [language]="lang"
          [theme]="theme"
          [setup]="null"
        ></code-editor>
      </div>
    </div>
  </div>
</div>

<div *ngIf="secondFileNodeId$ | async"></div>
<div *ngIf="isHighlighterReady$ | async"></div>
<div *ngIf="repo$ | async"></div>
<div *ngIf="struct$ | async"></div>
<div *ngIf="nav$ | async"></div>
<div *ngIf="isExplorer$ | async"></div>
<div *ngIf="fileNodeId$ | async"></div>
